import { gql } from "@edreamsodigeo/frontend-api-client";

const GET_PRIME_SITE_PROPERTIES = gql`
  query PrimeSitePropertiesQuery @ignore_update {
    primeSiteProperties {
      activePrimeMarket {
        flights
        cars
        hotels
        dynpack
      }
      isPossibleReturningPrimeVisitor
    }
  }
`;

export default GET_PRIME_SITE_PROPERTIES;
